// extracted by mini-css-extract-plugin
export default {"CheckItem":"CheckItem_CheckItem__2yPEy","input":"CheckItem_input__5XwFE"};